"use strict";
var _BookingItemsUpdate_instances, _BookingItemsUpdate_model, _BookingItemsUpdate_state, _BookingItemsUpdate_items, _BookingItemsUpdate_selecteds, _BookingItemsUpdate_getDeletedItems, _BookingItemsUpdate_getAddedItems, _BookingItemsUpdate_getUpdatedItems, _BookingItemsUpdate_destroyItems;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const structured_clone_1 = tslib_1.__importDefault(require("@ungap/structured-clone"));
const updateModel = {
    data: {
        type: 'booking',
        attributes: {
            booking_items_attributes: [],
        },
    },
};
class BookingItemsUpdate {
    constructor(bookingItems, listOfItems) {
        _BookingItemsUpdate_instances.add(this);
        _BookingItemsUpdate_model.set(this, void 0);
        _BookingItemsUpdate_state.set(this, []);
        _BookingItemsUpdate_items.set(this, []);
        _BookingItemsUpdate_selecteds.set(this, []);
        tslib_1.__classPrivateFieldSet(this, _BookingItemsUpdate_state, bookingItems, "f");
        tslib_1.__classPrivateFieldSet(this, _BookingItemsUpdate_items, listOfItems, "f");
        tslib_1.__classPrivateFieldSet(this, _BookingItemsUpdate_model, (0, structured_clone_1.default)(updateModel), "f");
    }
    set selectedsItems(data) {
        try {
            tslib_1.__classPrivateFieldSet(this, _BookingItemsUpdate_selecteds, data.map((selectedItem) => {
                var _a;
                const item = Array.from(tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_items, "f") || []).find((item) => String(item.internal_id) === String(selectedItem.itemInternalId));
                const itemId = (item === null || item === void 0 ? void 0 : item.id) || '';
                const vatPercentage = (item === null || item === void 0 ? void 0 : item.vat_percentage) || 0;
                // Only valid for updates
                const bookingId = ((_a = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_state, "f").find((bookingItem) => bookingItem.item.id === itemId)) === null || _a === void 0 ? void 0 : _a.id) || null;
                return {
                    ...selectedItem,
                    itemId,
                    bookingId,
                    vatPercentage,
                    tax_rate: item === null || item === void 0 ? void 0 : item.tax_rate,
                    taxable: item === null || item === void 0 ? void 0 : item.taxable,
                };
            }), "f");
            const deletedsIds = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_instances, "m", _BookingItemsUpdate_getDeletedItems).call(this, data);
            tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_instances, "m", _BookingItemsUpdate_destroyItems).call(this, deletedsIds);
            const addedItems = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_instances, "m", _BookingItemsUpdate_getAddedItems).call(this);
            tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_model, "f").data.attributes.booking_items_attributes = Array.from(tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_model, "f").data.attributes.booking_items_attributes).concat(addedItems);
            const updatedItems = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_instances, "m", _BookingItemsUpdate_getUpdatedItems).call(this);
            tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_model, "f").data.attributes.booking_items_attributes = Array.from(tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_model, "f").data.attributes.booking_items_attributes).concat(updatedItems);
        }
        catch {
            console.warn('[core]: set selected item handler');
        }
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_model, "f");
    }
}
exports.default = BookingItemsUpdate;
_BookingItemsUpdate_model = new WeakMap(), _BookingItemsUpdate_state = new WeakMap(), _BookingItemsUpdate_items = new WeakMap(), _BookingItemsUpdate_selecteds = new WeakMap(), _BookingItemsUpdate_instances = new WeakSet(), _BookingItemsUpdate_getDeletedItems = function _BookingItemsUpdate_getDeletedItems(selectedItems) {
    const deleteds = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_state, "f").filter((bookingItem) => {
        const willKeepItem = selectedItems.find((selectedItem) => {
            var _a, _b;
            return String(selectedItem.itemInternalId) ===
                String((_b = (_a = bookingItem === null || bookingItem === void 0 ? void 0 : bookingItem.item) === null || _a === void 0 ? void 0 : _a.internal_id) !== null && _b !== void 0 ? _b : '');
        });
        return !willKeepItem;
    });
    return deleteds.map((item) => item.id);
}, _BookingItemsUpdate_getAddedItems = function _BookingItemsUpdate_getAddedItems() {
    const currentBookingItemsId = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_state, "f").map((bookingItem) => bookingItem.item.id);
    const filteredSelecteds = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_selecteds, "f").filter((selectedItems) => !currentBookingItemsId.includes(selectedItems.itemId));
    const addedItems = filteredSelecteds.map((item) => {
        var _a, _b;
        const deposit_cents = (_b = (_a = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_items, "f").find((globalItem) => String(globalItem.id) === String(item.itemId))) === null || _a === void 0 ? void 0 : _a.deposit_amount) !== null && _b !== void 0 ? _b : 0;
        return {
            item_id: item.itemId,
            quantity: item.quantity,
            force_suggested_booking_cost: true,
            vat_percentage: item.vatPercentage,
            tax_rate: item.tax_rate,
            taxable: item.taxable,
            deposit_cents,
        };
    });
    return addedItems;
}, _BookingItemsUpdate_getUpdatedItems = function _BookingItemsUpdate_getUpdatedItems() {
    const currentBookingItemsId = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_state, "f").map((bookingItem) => bookingItem.item.id);
    const filteredSelecteds = tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_selecteds, "f").filter((selectedItems) => currentBookingItemsId.includes(selectedItems.itemId));
    const addedItems = filteredSelecteds.map((item) => ({
        id: item.bookingId || '',
        quantity: item.quantity,
    }));
    return addedItems;
}, _BookingItemsUpdate_destroyItems = function _BookingItemsUpdate_destroyItems(deletedIds) {
    deletedIds.forEach((itemToDestroy) => {
        tslib_1.__classPrivateFieldGet(this, _BookingItemsUpdate_model, "f").data.attributes.booking_items_attributes.push({
            id: itemToDestroy,
            _destroy: true,
        });
    });
    return this;
};
//# sourceMappingURL=index.js.map